import {AES, HmacMD5} from '@/lib/crypto/crypto.js'
import TerminalVendorEnum from '@/api/Enums/TerminalVendorEnum.js'

export default {
  computed: {
    terminalTransactionBusyTime() {
      return 30000
    }
  },
  methods: {
    getVendorById(vendorId) {
      const vendors = this.$te('Settings.Payment.Terminal.Vendor') ? Object.values(this.$t('Settings.Payment.Terminal.Vendor')) : []
      return vendors.find(vendor => vendor.Id === parseInt(vendorId)) || {}
    },

    getVendorAcquirerById(vendorId, acquirerCode) {
      return this.getVendorById(vendorId)?.Acquirer?.find(a => a.Value === acquirerCode)
    },

    getVendorAcquirerTextById(vendorId, acquirerCode) {
      const vendor = this.getVendorById(vendorId)
      const vendorAcquirer = this.getVendorAcquirerById(vendorId, acquirerCode)
      const retVal = vendor && vendorAcquirer ? [...new Set([vendor.Name, vendorAcquirer.Name, vendorAcquirer.SubAcquirer])] : []
      return retVal.join(' / ')
    },

    getVendorAcquirersList(vendorId, locale = this.$i18n.locale) {
      const vendors = Object.values(this.$t('Settings.Payment.Terminal.Vendor', locale))
      const acquirers = vendors?.find(v => v.Id === vendorId)?.Acquirer

      const acquirersArray = [...new Set([...(acquirers?.map(t => t.SubAcquirer) || []), ...(acquirers?.map(t => t.Name) || [])])]
      return acquirersArray?.sort((a, b) => a.localeCompare(b))?.join(', ') || ''
    },

    getTerminalErpGuideUrl(vendorId, terminalId) {
      const terminal = this.getTerminal(vendorId, terminalId)
      return terminal ? terminal.ErpGuideUrl : ''
    },

    getTerminal(vendorId, terminalId) {
      const vendor = this.getVendorById(vendorId)
      return vendor?.Devices?.find(terminal => terminal.Id === terminalId)
    },

    getTxnType(txnType) {
      return this.getTransactionType(txnType) || this.getTransactionTypeById(txnType) || null
    },
    getTransactionType(typeCode) {
      return typeCode && this.$te(`Payment.Transaction.Type.${typeCode}`) ? this.$t(`Payment.Transaction.Type.${typeCode}`) : null
    },
    getTransactionTypeById(typeId) {
      return Object.values(this.$t('Payment.Transaction.Type'))?.find(r => r.Id === typeId) || null
    },

    getTransactionStatus(statusCode) {
      return statusCode && this.$te(`Payment.Transaction.Status.${statusCode}`) ? this.$t(`Payment.Transaction.Status.${statusCode}`) : null
    },
    getTransactionStatusById(statusId) {
      return Object.values(this.$t('Payment.Transaction.Status'))?.find(r => r.Id === statusId) || null
    },

    getTransactionResult(resultCode) {
      return resultCode && this.$te(`Payment.Transaction.Result.${resultCode}`) ? this.$t(`Payment.Transaction.Result.${resultCode}`) : null
    },
    getTransactionResultTooltip(resultCode, params, message = '') {
      const result = resultCode && this.$te(`Payment.Transaction.Result.${resultCode}.Tooltip`) ? this.$t(`Payment.Transaction.Result.${resultCode}.Tooltip`, params) : null
      return result + (message && ('<br><div class="caption red--text text--lighten-5">' + message + '</div>') || '')
    },
    getTransactionResultById(resultId) {
      return Object.values(this.$t('Payment.Transaction.Result'))?.find(r => r.Id === resultId) || null
    },

    getVendorAcquirerTerminals(vendorId, acquirerCode) {
      const vendorTerminals = this.getVendorById(vendorId)?.Devices || []
      const vendorAcquirers = this.getVendorById(vendorId)?.Acquirer || []
      const acquirerTerminals = vendorAcquirers?.find(acquirer => acquirer.Value === acquirerCode)?.Devices || []
      return vendorTerminals.filter(terminal => acquirerTerminals?.includes(terminal.Id)).sort((a, b) => a?.Manufacturer?.localeCompare(b?.Manufacturer) || a?.Model?.localeCompare(b?.Model))
    },

    getEftPosTerminal(vendorCode, terminalId) {
      const vendor = this.appConfig?.POS_VENDORS?.find(vendor => vendor.Code === vendorCode)
      return vendor?.Terminals?.find(terminal => terminal.TerminalId === terminalId) || null
    },

    getAppDefaultTerminal() {
      const key = HmacMD5.hash('ActiveDeviceTerminal')
      const terminal = this.$localStorage.hasKey(key) ? AES.decrypt(this.$localStorage.get(key)) : null
      return this.getEftPosTerminal(terminal?.VendorCode, terminal?.TerminalId)
    },

    launchVivaTerminalAndroidApp(transaction) {
      const defaultAppTerminal = this.getAppDefaultTerminal()
      if (!transaction || !this.appIsAndroidPWA || defaultAppTerminal?.TerminalId !== transaction.TerminalId || defaultAppTerminal?.PosVendorCode !== transaction.TerminalVendorCode || transaction.TerminalVendorCode !== TerminalVendorEnum.VIVA) return

      const vivaPackageName = import.meta.env.MODE === 'production' ? 'com.vivawallet.spoc.payapp' : 'com.vivawallet.spoc.payapp.demo'
      const vivaScheme = 'vivapayclient'
      const vivaAction = 'foreground'
      const appId = 'com.getfoodpro.pos'
      const callback = import.meta.env.MODE === 'production' ? 'https://pos.getfoodpro.com' : 'https://dpos.getfoodpro.com'
      const intentUrl = `intent://pay/v1/?appId=${appId}&action=${vivaAction}&callback=${callback}#Intent;scheme=${vivaScheme};package=${vivaPackageName};end`

      try {
        const newWindow = window.open(intentUrl, '_system') // '_blank' Or '_system'
        if (newWindow) {
          newWindow.focus()
        } else {
          // Handle the case where the app was not opened
          // Redirect to the Play Store
          window.location.href = `https://play.google.com/store/apps/details?id=${vivaPackageName}`
        }
      } catch (error) {
        // Handle the error, perhaps the user has blocked popups
        console.error('Error launching app:', error)
        // Redirect to the Play Store
        window.location.href = `https://play.google.com/store/apps/details?id=${vivaPackageName}`
      }
    }
  }
}
